import { useState, useEffect } from 'react'

import { useLoadGoogleApi } from '@marketplace-web/domain/google-maps'

const useGoogleSession = (): google.maps.places.AutocompleteSessionToken | null => {
  const isGoogleApiLoaded = useLoadGoogleApi()
  const [sessionToken, setSessionToken] =
    useState<google.maps.places.AutocompleteSessionToken | null>(null)

  useEffect(() => {
    if (!isGoogleApiLoaded) return undefined

    setSessionToken(new window.google.maps.places.AutocompleteSessionToken())

    return () => setSessionToken(null)
  }, [isGoogleApiLoaded])

  return sessionToken
}

export default useGoogleSession
